// The order a list would be in if the held row were dropped at `at` (an index in that
// order). Pure, for the drag-and-drop hook and its tests.
export function moved(list, keyOf, held, at) {
  if (held == null || at == null) return list;
  const from = list.findIndex((x) => keyOf(x) === held);
  if (from < 0 || from === at) return list;
  const next = [...list];
  const [row] = next.splice(from, 1);
  next.splice(Math.max(0, Math.min(at, next.length)), 0, row);
  return next;
}

// How fast to scroll while a drag is near the top or bottom of the screen: nothing in the
// middle, faster the nearer the edge (px per frame).
export function edgeSpeed(y, height, edge = 72, max = 18) {
  if (y < edge) return -Math.ceil(((edge - y) / edge) * max);
  if (y > height - edge) return Math.ceil(((y - (height - edge)) / edge) * max);
  return 0;
}
